import React from 'react';
import { BaseText } from 'src/components/typography';
import { DassMetrics } from './utils/statistics';
import { getSeverityForScore } from './utils/severity';
import './DassStatistics.scss';

interface DassStatisticsProps {
  title: string;
  metrics: DassMetrics;
  color: string;
  version: 'DASS-21' | 'DASS-42';
}

const DassStatistics: React.FC<DassStatisticsProps> = ({ title, metrics, color, version }) => {
  const severity = getSeverityForScore(metrics.current, title as 'Depression' | 'Anxiety' | 'Stress', version);

  return (
    <div className="dass-stat-card" style={{ borderColor: color }}>
      <BaseText type="subHeading" className="stat-title" style={{ color }}>
        {title}
      </BaseText>
      
      <div className="stat-grid" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
        <div className="stat-item" style={{ textAlign: 'center', width: '100%' }}>
          <BaseText type="caption">Current</BaseText>
          <BaseText type="heading" style={{ fontSize: '36px', margin: '10px 0', width: '100%' }}>{metrics.current}</BaseText>
          <div className="severity-badge" style={{ backgroundColor: severity.color }}>
            {severity.category}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DassStatistics; 